import { z } from 'zod';
// Structural criteria the candidate pool bounds itself by in SQL, before any hard filter runs. A partner
// failing one of these is never a candidate, so the filters below say nothing about them.
export const matchingPoolCriterionTypeSchema = z.enum([
    'old-contract',
    'active-subscription',
    'team',
    'address',
    'postal-code',
    'work-categories',
    'not-already-assigned',
    'not-matched-on-original',
    'not-excluded-from-automatic-matching',
    'not-devis-team',
]);
export const matchingHardFilterTypeSchema = z.enum([
    'pause-forwarding',
    'information-requests',
    'emergency-requests',
    'customer-material',
    'max-leads-per-week',
    'sufficient-credits',
    'language',
    'minimum-volume',
    'validated-requests-only',
    'owner-only',
]);
// A filter the partner did not fail either passed or did not apply to them — their input loaders own the
// "skip" conditions and report the two the same way, so only a failure is a definite statement.
export const matchingCriterionSchema = z.object({
    type: z.union([matchingPoolCriterionTypeSchema, matchingHardFilterTypeSchema]),
    failed: z.boolean(),
});
// The stream whose pool the partner is judged against: an active subscription puts them in the subscription
// stream, everyone else is explained against the old-contract one.
export const matchingExclusionStreamSchema = z.enum(['old-contract', 'subscription']);
export const partnerMatchingExclusionSchema = z.object({
    partnerId: z.number().int(),
    partnerName: z.string(),
    // A partner the run already scored needs no re-checking: it demonstrably passed everything.
    wasScored: z.boolean(),
    stream: matchingExclusionStreamSchema,
    poolCriteria: z.array(matchingCriterionSchema),
    hardFilters: z.array(matchingCriterionSchema),
    // Both lists are evaluated against the state of things now, not the state the run saw.
    evaluatedAt: z.iso.datetime(),
});
